/**
 * API Configuration
 *
 * This file contains configuration settings for API endpoints.
 */

// Determine the base URL based on the environment
export const getApiBaseUrl = (): string => {
    // For local development, always use port 3000 for the API
    if (window.location.hostname === "localhost") {
        return "http://localhost:3000";
    }

    // For production or other environments, use the current origin
    return window.location.origin;
};

// API paths
export const API_PATHS = {
    CASES: "/cases",
    CHATS: (caseId: string) => `/cases/${caseId}/chats`,
    STATUS: (caseId: string) => `/cases/${caseId}/status`,
    MESSAGES: (caseId: string, sessionId: string) => `/cases/${caseId}/${sessionId}/send-message`
};
